import { Notification  } from 'element-ui';
import api from '@/api';
const OSS = require('ali-oss')

const MyMessage = {
    info:msg=>{Notification.info({title:'提示',message:msg,type: 'info'})},
    error:msg=>{Notification.error({title:'错误',message:msg,type: 'error'})},
    success:msg=>{Notification.success({title:'成功',message:msg,type: 'success'})},
    warning:msg=>{Notification.warning({title:'警告',message:msg,type: 'warning'})},
}
const notify = function(){
}
const loading = {
}

const MyStorage = {
    setItem:(key,value)=>{localStorage.setItem(key,value)},
    getItem:(key)=>{return localStorage.getItem(key)},
    removeItem:(key)=>{localStorage.removeItem(key)},
}


const getOSS=function(bucket,callback){
    let Expiration=localStorage.getItem('Expiration');
    if(!Expiration || (new Date()).valueOf()-Expiration>13*60*1000){
        api.getSTS(res=>{
            console.log(res);
            MyStorage.setItem('Expiration',(new Date()).valueOf());
            MyStorage.setItem('AccessKeySecret',res.data.AccessKeySecret);
            MyStorage.setItem('AccessKeyId',res.data.AccessKeyId);
            MyStorage.setItem('SecurityToken',res.data.SecurityToken);
            callback(new OSS({
                region: 'hangzhou',                    
                endpoint: 'http://oss-cn-hangzhou.aliyuncs.com',
                accessKeyId: res.data.AccessKeyId,          
                accessKeySecret: res.data.AccessKeySecret,  
                stsToken: res.data.SecurityToken,
                bucket: bucket
              }));
        });
    }else{
        callback(new OSS({
            region: 'hangzhou',                    
            endpoint: 'http://oss-cn-hangzhou.aliyuncs.com',
            accessKeyId: MyStorage.getItem('AccessKeyId'),          
            accessKeySecret: MyStorage.getItem('AccessKeySecret'),  
            stsToken: MyStorage.getItem('SecurityToken'),
            bucket: bucket
          }));
    }
  }

export {
    notify,loading,MyMessage,MyStorage,getOSS
}